import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';

const routes: Routes = [

  {
    path: '',
    loadComponent: () =>
      import('./landing/landing.component').then(m => m.LandingComponent),
    pathMatch: 'full'
  },

  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then(m => m.LoginModule)
  },

  {
    path: 'age-auth-home',
    loadComponent: () =>
      import('./age-auth-base/age-auth-home/age-auth-home.component')
        .then(m => m.AgeAuthHomeComponent),
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      {
        path: 'dashboard',
        data: { title: 'Dashboard' },
        loadComponent: () =>
          import('./age-auth-base/age-auth-dashboard/age-auth-dashboard.component')
            .then(m => m.AgeAuthDashboardComponent)
      },
      {
        path: 'main',
        data: { title: 'Home' },
        loadComponent: () =>
          import('./age-auth-base/age-auth-main/age-auth-main.component')
            .then(m => m.AgeAuthMainComponent)
      },
      {
        path: 'report',
        data: { title: 'Reports' },
        loadComponent: () =>
          import('./age-auth-base/age-auth-report/age-auth-report.component')
            .then(m => m.AgeAuthReportComponent)
      },
      {
        path: 'support',
        data: { title: 'Support' },
        loadComponent: () =>
          import('./age-auth-base/age-auth-support/age-auth-support.component')
            .then(m => m.AgeAuthSupportComponent)
      }
    ]
  },
  {
  path: 'unauthorized',
  loadComponent: () =>
    import('./unauthorized/unauthorized.component')
      .then(m => m.UnauthorizedComponent)
},
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
